import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  height: 142px;\n  gap: 8px;\n  justify-content: space-between;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _tagged_template_literal([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  flex: 1;\n  padding: 16px;\n  border-radius: 6px;\n  border: 1px solid ",
        ";\n  background-color: ",
        ";\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _tagged_template_literal([
        "\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 24px;\n  letter-spacing: -0.16px;\n  margin-bottom: 4px;\n  color: ",
        ";\n  text-overflow: ellipsis;\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-line-clamp: 1;\n  -webkit-box-orient: vertical;\n  word-break: break-all;\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _tagged_template_literal([
        "\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 22px; /* 157.143% */\n  letter-spacing: -0.14px;\n  color: ",
        ";\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _tagged_template_literal([
        "\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 22px; /* 157.143% */\n  letter-spacing: -0.14px;\n  color: ",
        ";\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = _tagged_template_literal([
        "\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 22px; /* 157.143% */\n  letter-spacing: -0.14px;\n  color: ",
        ";\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  width: 64px;\n  align-items: center;\n\n  /* flex-shrink: 0; */\n  /* padding: 0 11px; */\n  justify-content: center;\n  border-radius: 6px;\n  background-color: ",
        ";\n\n  :hover {\n    cursor: pointer;\n    background-color: ",
        ";\n  }\n\n  &.status-isMine {\n    background-color: ",
        ";\n\n    p {\n      color: ",
        ";\n    }\n\n    :hover {\n      cursor: default;\n    }\n  }\n"
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = _tagged_template_literal([
        "\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 24px; /* 150% */\n  letter-spacing: -0.16px;\n\n  color: ",
        ";\n"
    ]);
    _templateObject8 = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from "styled-components";
import Icon from "../icon/Icon";
import { Check_Thin, CouponDownload } from "../icon/IconList";
const Coupon = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ _jsx(CouponBox, {
        role: "listitem",
        children: children
    });
};
const Content = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ _jsx(CouponContents, {
        children: children
    });
};
const CouponTitle = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ _jsx(CouponTitleText, {
        children: children
    });
};
const CouponMaxDiscount = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ _jsx(MaxDiscountText, {
        children: children
    });
};
const CouponCondition = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ _jsx(ConditionText, {
        children: children
    });
};
const ExpireDate = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ _jsx(ExpireDateText, {
        children: children
    });
};
const Possession = (param)=>{
    let { status , onHandleClick  } = param;
    return /*#__PURE__*/ _jsx(IsOwnedStateArea, {
        role: "button",
        className: status ? "status-isMine" : "",
        onClick: onHandleClick,
        children: status ? /*#__PURE__*/ _jsxs(StateIcon, {
            children: [
                /*#__PURE__*/ _jsx(Icon, {
                    icon: Check_Thin,
                    color: "#A9AFC7"
                }),
                /*#__PURE__*/ _jsx(IconWithText, {
                    children: "보유중"
                })
            ]
        }) : /*#__PURE__*/ _jsxs(StateIcon, {
            children: [
                /*#__PURE__*/ _jsx(Icon, {
                    icon: CouponDownload,
                    color: "#513CBA"
                }),
                /*#__PURE__*/ _jsx(IconWithText, {
                    children: "받기"
                })
            ]
        })
    });
};
Coupon.Content = Content;
Coupon.Title = CouponTitle;
Coupon.MaxDiscount = CouponMaxDiscount;
Coupon.Condition = CouponCondition;
Coupon.ExpireDate = ExpireDate;
Coupon.Possession = Possession;
const CouponBox = styled.div.withConfig({
    componentId: "sc-b21a8b79-0"
})(_templateObject());
const CouponContents = styled.div.withConfig({
    componentId: "sc-b21a8b79-1"
})(_templateObject1(), (props)=>props.theme.new.colors.sol_gray_100, (props)=>props.theme.new.colors.white);
const CouponTitleText = styled.p.withConfig({
    componentId: "sc-b21a8b79-2"
})(_templateObject2(), (props)=>props.theme.new.colors.sol_gray_900);
const MaxDiscountText = styled.p.withConfig({
    componentId: "sc-b21a8b79-3"
})(_templateObject3(), (props)=>props.theme.new.colors.sol_red_400);
const ConditionText = styled.p.withConfig({
    componentId: "sc-b21a8b79-4"
})(_templateObject4(), (props)=>props.theme.new.colors.sol_gray_500);
const ExpireDateText = styled.p.withConfig({
    componentId: "sc-b21a8b79-5"
})(_templateObject5(), (props)=>props.theme.new.colors.sol_gray_300);
const IsOwnedStateArea = styled.div.withConfig({
    componentId: "sc-b21a8b79-6"
})(_templateObject6(), (props)=>props.theme.new.colors.sol_indigo_100, (props)=>props.theme.new.colors.sol_indigo_200, (props)=>props.theme.new.colors.sol_gray_50, (props)=>props.theme.new.colors.sol_gray_300);
const StateIcon = styled.div.withConfig({
    componentId: "sc-b21a8b79-7"
})(_templateObject7());
const IconWithText = styled.p.withConfig({
    componentId: "sc-b21a8b79-8"
})(_templateObject8(), (props)=>props.theme.new.colors.sol_indigo_600);
export default Coupon;
